import { ApolloError, WatchQueryFetchPolicy } from "apollo-client";
import { useMemo } from "react";
import { useQuery } from "react-apollo";
import GetMe from "src/hoc/repository/withMe/graphql/GetMe";
import { IUser } from "src/types/user";

interface IMe {
  me: IUser | null;
  loading: boolean;
  error: ApolloError | null;
}

interface IProps {
  fetchPolicy?: WatchQueryFetchPolicy;
}

export const useMe = ({ fetchPolicy = "cache-first" }: IProps = {}): IMe => {
  const { data, loading, error: rawError } = useQuery<{ me: IUser }>(GetMe, {
    fetchPolicy,
  });

  const { me } = data || { me: null };

  const error = useMemo(() => {
    const userNotLogged =
      rawError?.graphQLErrors.some(
        (e) => e.code === 401 && e.subError.code === 50
      ) ?? false;

    if (!userNotLogged && rawError) {
      return rawError;
    }

    return null;
  }, [rawError]);

  return { me, loading, error };
};
